import React           from 'react';
import { AuthContext } from '@widesk-ui/contexts/AuthContext';

export function useAuth() {
	return React.useContext(AuthContext);
}
